export default {
      id: "amex-usage",
      viewBox: "0 -0.5 32 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#amex",
      toString: function () {
        return this.url;
      }
    }